import React from 'react'
import styled from '@emotion/styled'
import { breakpoints } from "utils/styles"

const Container = styled.div`
	display: none;
	h4 {
		font-size: 1.5rem;
		font-weight: 400;
		margin-bottom: 0px;
		color: #343a40;
		@media (max-width: ${breakpoints.mobile}px) {
			font-size: 1.2rem;
		}
	}
	justify-content: space-between;
	align-items: center;
	max-width: 600px;
	margin: 0 auto;
	margin-bottom: 100px;
	/*border: 1px solid #e9ecef;*/
	border-radius: 4px;
	padding: 2.8rem 2.4rem;
	background: #fff;
	@media (min-width: ${breakpoints.phablet}px) {
		text-align: left;
		display: none;
	}
`

const Button = styled.button`
	background-color: #fff;
    color: #ff0000;
    border: 1px solid #e9ecef;
    /*box-shadow: 0 0.2rem 0.5rem rgba(103,110,144,.2), 0 0 0 0.1rem rgba(103,110,144,.05);*/
    font-size: .8rem;
    line-height: 1;
    padding: 1.3em 1.6em;
    border-radius: .3rem;
    font-weight: bolder;
    cursor: pointer;
    transition: box-shadow 200ms;
    text-align: center;
    /*text-transform: uppercase;*/
    &:hover {
    	box-shadow: 0 0.2rem 0rem rgba(103,110,144,.1), 0 0 0 0.1rem rgba(103,110,144,.05);
    }
`

const Small = styled.p`
	margin-bottom: 0px;
	color: #ff0000;
	font-weight: 600;
	@media (max-width: ${breakpoints.phablet}px) {
		margin-bottom: 30px;
	}
`

export default () => (
	<Container>
		<div>
		<h4>Curious? Text Chris.</h4>
		</div>
		<a href="sms:+16319934016"><Button>Text (631)-993-4016</Button></a>
	</Container>
)